import React, { useState } from 'react';
import '@components/module-components/POSMap/pos-map.scss';
import { calculateCurveV2 } from '@components/module-components/POSMap/helper';
import { useSelector } from "react-redux";
import { Polyline } from "@react-google-maps/api";
import _ from "lodash-es";
import { ProcessData } from './types';

interface ProcessCurveMapProps {
  curveMap: Array<{
    line: {
      path: google.maps.LatLng[];
      geodesic: boolean;
      strokeOpacity: number;
      icons: Array<{
        icon: {
          path: string;
          strokeOpacity: number;
          scale: number;
        };
        offset: string;
        repeat: string;
      }>;
      strokeColor: string;
    };
  }>;
}

const ProcessCurveMap: React.FC<ProcessCurveMapProps> = ({ curveMap = [] }) => {
  return (
    <>
      {curveMap.length > 0 && curveMap.map((curv, idx) => (
        <div key={`curve_map_${idx}_${_.uniqueId()}`}>
          <Polyline options={{ ...curv.line }} />
        </div>
      ))}
    </>
  );
};

interface ProcessesMarkersProps {
  data: ProcessData[];
}

export const ProcessesMarkers: React.FC<ProcessesMarkersProps> = ({ data = [] }) => {
  const langData = useSelector((state: any) => state.currentLanguage);
  const [locHover, setLocHover] = useState<number | null>(null);
  const [locClick, setLocClick] = useState<number | null>(null);

  // Calculate curve map once, don't recalculate on re-renders
  const { curveMap, streets } = calculateCurveV2(data);

  return (
    <>
      <ProcessCurveMap curveMap={curveMap} />
    </>
  );
};

export default React.memo(ProcessesMarkers);